import {AppBlock} from "@ok/web/modules/block/AppBlock";
import {RbAdBannerFeedListStore} from "./RbAdBannerFeedListStore";
import {RbAdBannerFeedList} from "../components/RbadbannerFeedlist/RbAdBannerFeedList";
import {RbAdBannerFeedListController} from "./RbAdBannerFeedListController";
import {IRbAdBannerFeedListAttrs} from "./RbAdBannerFeedListAttrs";

export class RbAdBannerFeedListBlock extends AppBlock<IRbAdBannerFeedListAttrs, {}, RbAdBannerFeedListStore, RbAdBannerFeedListController> {
    getAppAPI() {
        return {};
    }

    getAppEntities() {
        return {
            Store: RbAdBannerFeedListStore,
            Controller: RbAdBannerFeedListController,
            Component: RbAdBannerFeedList
        };
    }
}
